export const loading = (state) => state.loading;
export const valerrors = (state) => state.valerrors;
export const flashBanner = (state) => state.flashBanner;
export const pictures = (state) => state.pictures;
export const settings = (state) => state.settings;
export const user = (state) => state.user;
